import { ASSISTANT_MESSAGE_STATUS } from '@atlassian/unified-help-common/src/types';
import type { AssistantMessage } from '@atlassian/unified-help-common/src/types';

export const initialAssistantMessage = (answerId: number): AssistantMessage => ({
	aiMateConversationResponse: {
		message: {
			id: String(answerId),
			time_created: '',
			user_ari: '',
			role: 'assistant',
			content: '',
			plugin_invocations: [],
		},
	},
	userType: 'assistant',
	messageMetadata: {
		status: ASSISTANT_MESSAGE_STATUS.AWAITING_RESPONSE,
		messageId: answerId.toString(),
	},
});
